import type { ReactNode } from "react";

import { Center } from "@freightsimple/ui-core/PageLayout/Center";
import { Logo } from "@freightsimple/ui-core/Display/Logo";
import { Panel } from "@freightsimple/ui-core/PageLayout/Panel";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";

import { ShopifyConnectPageSurface } from "../CustomComponents/Internal/ShopifyConnectPageSurface";

/**
 * Branded, popup-sized card for the Shopify connect flow — a slimmed-down cousin of
 * AuthenticationScreenContainer that fits the 520×720 connect popup (that container's fixed 688px
 * section would overflow it). Single centred column: FreightSimple logo, then the state body.
 */
export function ShopifyConnectCard_({
  children,
  hideLogo = false,
}: {
  children: ReactNode;
  // The sign-in state embeds SignInForm, which brings its own logo — hide the card's to avoid two.
  hideLogo?: boolean;
}) {
  return (
    <ShopifyConnectPageSurface>
      <Center minHeight="calc(100vh - 48px)" maxWidth={420}>
        <Panel>
          <Stack gap={6} align="center">
            {!hideLogo && <Logo />}
            {children}
          </Stack>
        </Panel>
      </Center>
    </ShopifyConnectPageSurface>
  );
}

/** Centres a progress spinner (a fixed-size block) within the card's centred column. */
export function ConnectShopifySpinnerRow_({
  children,
}: {
  children: ReactNode;
}) {
  return <Row justify="center">{children}</Row>;
}
